exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".center {\r\n    width: 80%;\r\n    padding: 100px;\r\n    margin-left: 10%;\r\n}\r\n\r\n.vl {\r\n  border-left: 1px solid;\r\n  height: 400px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/auth/user-login/user-login.component.css
// module id = ../../../../../src/app/auth/user-login/user-login.component.css
// module chunks = main